import { datadogRum } from '@datadog/browser-rum';
import getConfig from 'next/config';

import { isServer } from '@/constants/env';

(() => {
  if (isServer) return;

  const {
    currentVersion: version,
    datadog: { environment: env, applicationId, clientToken, service, enabled },
  } = getConfig().publicRuntimeConfig;

  if (!(enabled && env && applicationId && clientToken && service)) return;

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
})();
